import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import { useLanguage } from '../../i18n/LanguageContext';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
);

const BackButton: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate('/services/catalog');
  };

  const label = language === 'it' ? 'Indietro' : 'Back';

  return (
    <Wrapper>
      <Button
        variant="outline"
        size="small"
        aria-label={label}
        onClick={handleGoBack}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleGoBack();
          }
        }}
        icon={<Icon />}
      >
        {label}
      </Button>
    </Wrapper>
  );
};

export default BackButton;
